export function getLocalizedPath (slug, language, generateDefaultLanguagePage) {
  if (language === 'en' && !generateDefaultLanguagePage) {
    return slug.startsWith('/') ? slug : `/${slug}`
  }
  return `/${language}${slug.startsWith('/') ? '' : '/'}${slug}`
}
